(function($) {

  $('.page-header')
    .on('mouseover', function(){
      //$(this).children('.jiggle-container').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
      $(this).children('.jiggle-container').css({'transform': 'scale(1.02)'});
    })
    .on('mouseout', function(){
      $(this).children('.jiggle-container').css({'transform': 'scale(1)'});
    })
    .on('mousemove', function(e){
      $(this).children('.jiggle-container').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
  })

})(jQuery);
